//Aqui se defiene las variables para el control y manejo de los campos de toda la app

import credicard from "../assets/svg/tdc-nacional.svg";
import bs from "../assets/svg/bolivares.svg";
import ds from "../assets/svg/dolares.svg";
import credito from "../assets/svg/tdc-internacional.svg";
import credito2 from "../assets/svg/tdc-internacional2.svg";
import masterDebit from "../assets/svg/masterDebit.svg";

import tpago from "../assets/svg/pagomovil.svg";
import zelleLogo from "../assets/bancos/newLogos/zelle-50.png";
import banesco from "../assets/bancos/newLogos/banesco-50.png";
import mercantil from "../assets/bancos/newLogos/mercantil-50.png";
import bancoVenezuela from "../assets/bancos/newLogos/bdv-50.png";
import bancamiga from "../assets/bancos/newLogos/bancamiga-50.png";
import bancrecer from "../assets/bancos/newLogos/bancrecer-50.png";
import tesoro from "../assets/bancos/newLogos/banco-del-tesoro-50.png";
import mibanco from "../assets/bancos/newLogos/R4.png";
import bancaribe from "../assets/bancos/newLogos/bancaribe-50.png";

export const optionPhone = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "0414" },
  { id: 3, name: "0424" },
  { id: 4, name: "0412" },
  { id: 7, name: "0422" },
  { id: 5, name: "0426" },
  { id: 6, name: "0416" },
];

export const optionCI = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "V" },
  { id: 3, name: "E" },
  { id: 4, name: "P" },
];
export const optionRIF = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "V" },
 // { id: 3, name: "E" },
  { id: 4, name: "J" },
 // { id: 5, name: "P" },
  { id: 6, name: "G" },
];
export const optionPyment = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "V" },
  { id: 3, name: "E" },
  { id: 4, name: "J" },
  { id: 5, name: "G" },
  { id: 6, name: "P" },
];
export const optionAccount = [
  { id: 0, name: "Seleccione" },
  { id: 1, name: "Ahorro" },
  { id: 2, name: "Corriente" },
];
export const optionPymentAllBancos = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "Corriente" },
  { id: 3, name: "Ahorro" },
  { id: 4, name: "Principal" },
];
export const optionPymentAllMercantil = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "Corriente" },
  { id: 3, name: "Ahorro" },
];
export const optionPymentType = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "Débito" },
];

export const optionMes = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "01" },
  { id: 3, name: "02" },
  { id: 4, name: "03" },
  { id: 5, name: "04" },
  { id: 6, name: "05" },
  { id: 7, name: "06" },
  { id: 8, name: "07" },
  { id: 9, name: "08" },
  { id: 10, name: "09" },
  { id: 11, name: "10" },
  { id: 12, name: "11" },
  { id: 13, name: "12" },
];

export const optionAno = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "2018" },
  { id: 3, name: "2019" },
  { id: 4, name: "2020" },
  { id: 5, name: "2021" },
  { id: 6, name: "2022" },
  { id: 7, name: "2023" },
  { id: 8, name: "2024" },
  { id: 9, name: "2025" },
  { id: 10, name: "2026" },
  { id: 11, name: "2027" },
  { id: 12, name: "2028" },
  { id: 13, name: "2029" },
  { id: 14, name: "2030" },
  { id: 15, name: "2031" },
  { id: 16, name: "2032" },
  { id: 17, name: "2033" },
  { id: 18, name: "2034" },
  { id: 19, name: "2035" },
];
export const optionAnoMercantil = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "2024" },
  { id: 3, name: "2025" },
  { id: 4, name: "2026" },
  { id: 5, name: "2027" },
  { id: 6, name: "2028" },
  { id: 7, name: "2029" },
  { id: 8, name: "2030" },
  { id: 9, name: "2031" },
  { id: 10, name: "2032" },
  { id: 11, name: "2033" },
  { id: 12, name: "2034" },
  { id: 13, name: "2035" },
];
export const initialPayments = {
  payments: "",
};

export const typePayments = {
  payments: "",
};
export const typeAcc = [
  {
    id: 1,
    title: "Ahorro",
  },
  {
    id: 2,
    title: "Corriente",
  },
];
export const formPagoMovil = {
  selectDoc: "",
  typeDoc: "",
  selectNumber: "",
  phone: "",
  numberReference: "",
  amount: "",
  date: "",
  banks: null,
};
export const pagoBancoVenezuela = {
  email: "",
  //phone: "",
  selectDoc: "",
  typeDoc: "",
  name: "",
  cuenta: "",
  transaccion: "",
  tipoCuenta: ""
};
export const formPagoMercantil = {
  numberCard: "",
  selectDoc: "",
  typeDoc: "",
  typeAccount: "",
  dateExpirationDay: "",
  dateExpirationMonth: "",
  name: "",
  code: "",
  keyPhone: "",
};
export const formCreditCard = {
  typeAccount: "",
  selectDoc: "",
  typeDoc: "",
  numberCardCredicard: "",
  month: "",
  year: "",
  name: "",
  cvc: "",
  typeCard: "",
  selectNumber: "",
  phone: "",
  token: "",
  pinCard: "",
};

export const formPagoMercantilTDC = {
  numberCardCredit: "",
  selectDoc: "",
  typeDoc: "",
  month: "",
  year: "",
  code: "",
};
export const opCurrency = [
  {
    id: 1,
    title: "Dólares",
    logo: ds,
  },
  {
    id: 2,
    title: "Bolívares",
    logo: bs,
  },
];
export const formZelle = {
  nameZelle: "",
  email: "",
  lastNameZelle: "",
  date: "",
  confirmation: "",
};
export const formTarjetaCredito = {
  name: "",
  month: "",
  year: "",
  email: "",
  cvvCard: "",
  numberCardCredit: "",
};


export const optionsBs = [
  {
    id: 1,
    title: "Pago Móvil",
    category: "confimacion",
    status: 1,
    logo: tpago,
  },

  {
    id: 2,
    title: "Débito Nacional",
    category: "confimacion",
    status: 1,
    logo: credicard,
  },
  {
    id: 3,
    title: "Crédito Nacional",
    category: "confimacion",
    status: 1,
    logo: credito,
  },
  {
    id: 4,
    title: "Master Debit",
    category: "confimacion",
    status: 1,
    logo: masterDebit,
  },
];
export const optionsDolares = [
  {
    id: 1,
    title: "Zelle",
    category: "confimacion",
    status: 1,
    logo: zelleLogo,
  },
  {
    id: 2,
    title: "Tarjeta Internacional",
    category: "confimacion",
    status: 1,
    logo: credito2,
  },
];
export const amountPayment = {
  amount: "",
};
export const opCredicard = [
  {
    id: 1,
    title: "Banco de Venezuela",
    category: "confimacion",
    status: 1,
    logo: bancoVenezuela,
  },
  {
    id: 2,
    title: "Banesco",
    category: "confimacion",
    status: 1,
    logo: banesco,
  },
  {
    id: 3,
    title: "Mercantil",
    category: "confimacion",
    status: 1,
    logo: mercantil,
  },
  // {
  //   id: 4,
  //   title: "Otros Bancos",
  //   category: "confimacion",
  //   status: 1,
  //   logo: credicard,
  // },
 /*  {
    id: 4,
    title: "Bancaribe",
    category: "confimacion",
    status: 1,
    logo: bancaribe,
  },
  {
    id: 5,
    title: "Bancrecer",
    category: "confimacion",
    status: 1,
    logo: bancrecer,
  },
  {
    id: 6,
    title: "Banco del Tesoro",
    category: "confimacion",
    status: 1,
    logo: tesoro,
  },
  {
    id: 7,
    title: "Bancamiga",
    category: "confimacion",
    status: 1,
    logo: bancamiga,
  },
  {
    id: 8,
    title: "R4 Banco Microfinanciero",
    category: "confimacion",
    status: 1,
    logo: mibanco,
  },   */
];
export const opOtrosBancos = [
  {
    id: 3,
    title: "Bancaribe",
    category: "confimacion",
    status: 1,
    logo: bancaribe,
  },
  {
    id: 4,
    title: "Bancrecer",
    category: "confimacion",
    status: 1,
    logo: bancrecer,
  },
  {
    id: 5,
    title: "Banco del Tesoro",
    category: "confimacion",
    status: 1,
    logo: tesoro,
  },
  {
    id: 6,
    title: "Bancamiga",
    category: "confimacion",
    status: 1,
    logo: bancamiga,
  },
  {
    id: 7,
    title: "R4 Banco Microfinanciero",
    category: "confimacion",
    status: 1,
    logo: mibanco,
  },
];
export const banks = [
  { name: "Seleccione el Banco" },
  { name: "0001 Banco Central de Venezuela" },
  { name: "0102 Banco de Venezuela S.A." },
  { name: "0104 Venezolano de Crédito S.A." },
  { name: "0105 Banco Mercantil, C.A" },
  { name: "0108 Banco Provincial, S.A." },
  { name: "0114 Bancaribe C.A." },
  { name: "0115 Banco Exterior C.A." },
  { name: "0116 Banco Occidental de Descuento, C.A." },
  { name: "0128 Banco Caroní C.A." },
  { name: "0134 Banesco S.A.C.A." },
  { name: "0137 Banco Sofitasa C.A." },
  { name: "0138 Banco Plaza C.A." },
  { name: "0146 Banco de la Gente Emprendedora C.A." },
  { name: "0149 Banco del Pueblo Soberano, C.A." },
  { name: "0151 BFC Banco Fondo Común C.A." },
  { name: "0156 100 % Banco, C.A." },
  { name: "0157 Del Sur, C.A." },
  { name: "0163 Banco del Tesoro, C.A." },
  { name: "0166 Banco Agrícola de Venezuela, C.A." },
  { name: "0168 Bancrecer, S.A." },
  { name: "0169 R4 Banco Microfinanciero C.A." },
  { name: "0171 Banco Activo, C.A." },
  { name: "0172 Bancamiga, C.A." },
  { name: "0173 Banco Internacional de Desarrollo, C.A." },
  { name: "0174 Banplus, C.A." },
  { name: "0175 Banco Bicentenario C.A." },
  { name: "0177 Banco de la Fuerza Armada Nacional Bolivariana" },
  { name: "0190 Citibank N.A." },
  { name: "0191 Banco Nacional de Crédito, C.A." },
  { name: "0601 Instituto Municipal de Crédito Popular" },
];
